import { uniqBy } from 'lodash'
/*
 * Check if some of the connected wallboxes share the same name(usually the default hardware name).

 * This information is used to conditionally append wallbox id next to the wallbox name in the table to
 * differentiate between two wallboxes sharing the same name.
 */

export const getDuplicateWallboxNames = (wallboxes: { id: string; name?: string }[]): string[] => {
  const wallboxesUniqueById = uniqBy(wallboxes, wallbox => wallbox.id)
  const wallboxNameCounts: Record<string, number> = {}

  wallboxesUniqueById.forEach(wallbox => {
    if (!wallbox.name) {
      return
    }

    wallboxNameCounts[wallbox.name] = (wallboxNameCounts[wallbox.name] || 0) + 1
  })

  const duplicateWallboxNames = Object.keys(wallboxNameCounts).filter(name => wallboxNameCounts[name] > 1)

  return duplicateWallboxNames
}
